import { BigintIsh } from '~/types';

export function toBigInt(num: BigintIsh): bigint {
  return BigInt(num.toString());
}
